import { render } from "./my-details-and-documents-component.vue?vue&type=template&id=41c1942a"
import script from "./my-details-and-documents-component.vue?vue&type=script&lang=js"
export * from "./my-details-and-documents-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__